import axios from 'axios';
import React from 'react'
import { Component } from 'react';
import { Loader } from '../../../common/loader/loader.jsx';
import { BlogJSX } from './blogs.jsx'
import { baseURL} from "../../../../constants/applicationConstants.js";

export default class Blogs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            blogData: null,
            isProcessing: false,
            expertData: null,
            expertBlogData: null,
            page: 1,
            page1: 1
        }
    }

    getBlogData = () => {
        const name = JSON.parse(localStorage.getItem("masterID"));
        const token = JSON.parse(localStorage.getItem('token'));



        axios.get(`${baseURL}/articles?page=${this.state.page}&limit=-1&expertid=${name}`,
            {
                headers: { 'x-access-token': token }
            }).then(res => {
                this.setState({ blogData: res.data.data.body, isProcessing: false });
            }).catch(err => {
                this.setState({ isProcessing: false })
            })


        if (!token) {
            this.props.history.push("/");
        }
    }
    getExpertsProductData = () => {
        const name11 = localStorage.getItem("slugSet");
        const token = JSON.parse(localStorage.getItem('token'));
     

        axios.get(`${baseURL}/articles?page=1&limit=-1&expertid=${name11 || null}`,
            {
                headers: { 'x-access-token': token }
            }).then(res => {
                this.setState({ expertBlogData: res.data.data.body, isProcessing: false });
            }).catch(err => {
                this.setState({ isProcessing: false })
            })
        if (!token) {
            this.props.history.push("/");
        }


    }
    getExpertData = () => {
        let token = JSON.parse(localStorage.getItem('token'));
        let instituteId = JSON.parse(localStorage.getItem("masterID"));
        this.setState({ isLoading: true })

        axios.get(`${baseURL}/institute/${instituteId}/experts`, {
            headers: { 'x-access-token': token }
        }).then(res => {
            this.setState({ expertData: res.data.data, isLoading: false })
            this.getInstitutionName()
        }).catch(err => {
            this.setState({ isLoading: false })
        })
    }

    getInstitutionName = () => {
        let tempArr = [];

        this.state.expertData?.forEach(cat => {

            tempArr.push(cat?.slugUrl)
        })
        localStorage.setItem("slugSet", tempArr.join())




    }

    componentDidMount = () => {
        this.getExpertData();
        setTimeout(() => {
            this.getBlogData();
            this.getExpertsProductData();
        }, 2000)


    }

    onPaginationButtonClick = (page) => {
        const element = document.getElementById('articlePanel2');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
        this.setState({ page: page })
    }
    onPaginationButtonClick1 = (page) => {
        
        
        const element = document.getElementById('articlePanel');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
        this.setState({ page1: page })
    }

    render() {
        return (
            <div>
                <BlogJSX
                    blogData={this.state.blogData}
                    expertData={this.state.expertData}
                    expertBlogData={this.state.expertBlogData}
                    onPaginationButtonClick={this.onPaginationButtonClick}
                    onPaginationButtonClick1={this.onPaginationButtonClick1}

                    page={this.state.page}
                    page1={this.state.page1}
                />
                {this.state.isProcessing && <Loader />}
            </div>
        )
    }
}